import ConfigurationHelper from "../configuration/ClientConfigurationHelper";

class Request {
    constructor(isV3 = false) {
        this.parameters = {};
        if(!isV3)
            this.parameters["X-login-id"] = ConfigurationHelper.getGlobalConfiguration().loginId;
        
    }

    isValid(toEvaluate) {
        let isValid = true;
        if ('undefined' === typeof toEvaluate)
            isValid = false;
        else if ('string' === typeof toEvaluate && !toEvaluate.length)
            isValid = false;
        else if (toEvaluate === null)
            isValid = false;
        return isValid;
    }

    withChannel(channelId) {
        if (this.isValid(channelId))
            this.parameters["channelId"] = channelId;
        return this;
    }

    withPage(page) {
        if (this.isValid(page))
            this.parameters["p"] = page;
        return this;
    }

    withPageV3(page) {
        if (this.isValid(page))
            this.parameters["page"] = page;
        return this;
    }

    withNumberOfItemsV3(number) {
        if (this.isValid(number))
            this.parameters["per_page"] = number;
        return this;
    }

    withNumberOfItems(number) {
        if (this.isValid(number))
            this.parameters["n"] = number;
        return this;
    }

    withQuery(query) {
        if (this.isValid(query))
            this.parameters["s"] = query;
        return this
    }

    withStatus(status) {
        if (this.isValid(status))
            this.parameters["status"] = status;
        return this
    }

    withOwnerId(id) {
        if (this.isValid(id))
            this.parameters["user_id"] = id;
        return this
    }

    getParameters() {
        return this.parameters
    }
}

export default Request;